import { max} from '@vee-validate/rules';
import { defineRule } from 'vee-validate';

defineRule('unique-term-name', (value, { isExistingTerm, isDuplicateTerm }) => {
    if (!isDuplicateTerm(value)) return true;
    if (isExistingTerm(value)) {
        return 'Term name already in use.';
    }
    return 'Cannot import multiple terms with same name.';
});

export default {
    data() {
        return {
            termConfiguration: {
                type: 'terms',
                label: 'Terms',
                sampleNotes: [
                    '"Dates are expected to be in YYYY-MM-DD."'
                ],
                fields: [
                    {
                        key: 'Name',
                        label: 'Name',
                        hasErrorCalculator:  (value, row, checkOriginalData) => {
                            return (
                                this.isEmpty(value)
                                || max(value, { length: 80 }) !== true
                                || this.isDuplicateTerm(value, checkOriginalData)
                            );
                        },
                        
                        rules: {
                            'unique-term-name': {
                                isExistingTerm: this.isExistingTerm,
                                isDuplicateTerm: this.isDuplicateTerm
                            },
                            max: {length: 80},
                            required: true
                        },
                        samples: ['"2022AGRE"','"2022BGRE"','"2022CGRE"']
                    },       
                    {
                        key: 'Description',
                        label: 'Description',
                        canConvertCase: true,
                        hasErrorCalculator: value => {
                            return (
                                max(value, { length: 255 }) !== true
                            );
                        },
                        rules: 'max:255',
                        samples: [
                            '"Text Description for term"',
                            '""',
                            '""'
                        ]
                    },              
                    {
                        key: 'CampusName',
                        label: 'Campus Name',
                        dataType: 'campuses',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) || !this.matchesExistingObject(value);
                        },
                        rules: 'required|min_value:0',
                        samples: [
                            '"Greenville University"',
                            '"Greenville University"',
                            '"Greenville University"']
                    },
                    {
                        key: 'ClassStartDate',
                        label: 'Class Start Date',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) ||  !this.isValidDate(value);
                        },
                        rules: {
                            'valid-date': {
                                isValidDate: this.isValidDate,
                                propertyName: 'ClassStartDate'
                            },
                            required: true
                        },
                        inputType: 'date',
                        addRowDataToRule: 'valid-date',
                        samples: [
                            '"2022-10-09"',
                            '"2022-10-09"',
                            '"2022-10-05"'
                        ]
                    },
                    {
                        key: 'IsOpen',
                        label: 'Is Open',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) || !this.matchesExistingObject(value);
                        },
                        rules: 'required|min_value:0',
                        samples: ['Yes', 'No', 'Yes'],
                        dataType: 'yesNoOptions'
                    },
                    {
                        key: 'IsActive',
                        label: 'Is Active',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) || !this.matchesExistingObject(value);
                        },
                        rules: 'required|min_value:0',
                        samples: ['Yes', 'No', 'Yes'],
                        dataType: 'yesNoOptions'
                    },
                    {
                        key: 'SubtractOrderShort',
                        label: 'Subtract Order Short',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) || !this.matchesExistingObject(value);
                        },
                        rules: 'required|min_value:0',
                        samples: ['Yes', 'No', 'Yes'],
                        dataType: 'yesNoOptions'
                    },
                    {
                        key: 'BuybackToSubtract',
                        label: 'Buyback to Subtract',
                        hasErrorCalculator: value => {
                            return this.isEmpty(value) || !this.matchesExistingObject(value);
                        },
                        rules: 'required|not_one_of:-1',
                        samples: ['None', 'Estimated', 'Actual'],
                        dataType: 'buybackToSubtractOptions'
                    },
                ]
            }
        };
    },
    methods: {
        isDuplicateTerm(termName, rowData, checkOriginalData) {
            return this.isExistingTerm(termName) 
                    || this.isDuplicatedOnImportTerm(termName, rowData, checkOriginalData);                
        },

        isExistingTerm(termName) {
            return (
                termName != '' &&
                this.selectListOptions.terms.some(x => x.name.toLowerCase() === termName.toLowerCase())
            );
        },
        isDuplicatedOnImportTerm(termName, checkOriginalData) {
            return (
                termName != '' &&
                this.loadedData.filter(x => x.Name.toLowerCase() === termName.toLowerCase() 
                    || (checkOriginalData &&
                        x.originalData?.Name.toLowerCase()  === termName.toLowerCase() )).length > 1
            );
        }
    }
       
};
